import { OverlayContainer } from "@angular/cdk/overlay";
import { Component, ChangeDetectionStrategy } from "@angular/core";
import { IconComponent } from "@claas/claas-ui-components";
import { TranslatePipe } from "@ngx-translate/core";
import { CustomOverlayContainer } from "../../../../core/providers/custom-overlay-container";
import { AsideModalDialog } from "../../aside-modal-dialog/aside-modal-dialog";
import { DocumentSettingsModal } from "../document-settings-modal";

@Component({
  selector: "claas-document-settings-modal-button",
  providers: [
    {
      provide: OverlayContainer,
      useFactory: () =>
        new CustomOverlayContainer("[data-document-settings-modal-overlay]"),
    },
  ],
  imports: [
    IconComponent,
    TranslatePipe,
    AsideModalDialog,
    DocumentSettingsModal,
  ],
  templateUrl: "./document-settings-modal-button.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./document-settings-modal-button.scss",
})
export class DocumentSettingsModalButton {
  showDocumentsSettingsModal = false;

  setShowDocumentsSettingsModal(val: boolean) {
    this.showDocumentsSettingsModal = val;
  }
}
